import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  useGetProviderAvatarByIdQuery,
  useGetProviderByIdQuery,
  useGetProviderInfoWithHistoryByIdQuery,
} from '~/store/services/providers';

export const useProviderProfileData = (
  providerExternalId: string,
  isAdmin: boolean,
) => {
  const { providerTypePkTransition: isProviderTypePkTransitionEnabled } =
    useFlags<LDFlags>();
  const shouldFetchV1 =
    !isProviderTypePkTransitionEnabled && !!providerExternalId;
  const shouldFetchV2 =
    isProviderTypePkTransitionEnabled && !!providerExternalId;

  const { data: providerDataV1, isLoading: isLoadingV1 } =
    useGetProviderByIdQuery(
      {
        provideAuthDetails: isAdmin,
        providerExternalId,
      },
      { skip: !shouldFetchV1 },
    );

  const shouldFetchAvatar = shouldFetchV1 && !!providerDataV1?.userId;

  const { data: avatarDataV1 } = useGetProviderAvatarByIdQuery(
    {
      providerExternalId: providerDataV1?.userId,
    },
    {
      skip: !shouldFetchAvatar,
    },
  );

  const { data: providerDataV2, isLoading: isLoadingV2 } =
    useGetProviderInfoWithHistoryByIdQuery(
      {
        includeAvatar: true,
        provideAuthDetails: isAdmin,
        providerExternalId,
      },
      { skip: !shouldFetchV2 },
    );

  const providerData = isProviderTypePkTransitionEnabled
    ? providerDataV2
    : providerDataV1;

  const isLoading = isProviderTypePkTransitionEnabled
    ? isLoadingV2
    : isLoadingV1;

  const avatarUrl = isProviderTypePkTransitionEnabled
    ? providerDataV2?.avatar?.thumbnailUrl || providerDataV2?.avatar?.url
    : avatarDataV1?.url;

  return {
    providerData,
    avatarUrl,
    isLoading,
    isProviderTypePkTransitionEnabled,
  };
};
